/* @flow */

import React from 'react';
import type { $Configuration } from '../../types/Configuration';
import type { $Dealer } from '../../types/Dealer';
import type { $Translation } from '../../types/Translation';
import DealerDistance from './DealerDistance';
import WidgetDealerKeys from '../../constants/WidgetDealerKeys';
import { showWidgetField } from '../../utils/WidgetFieldUtils';

type $Props = {
  dealer: $Dealer,
  configuration: $Configuration,
  translations: Array<$Translation>,
  settings?: Object,
  modifierClass?: string
};

const DealerAddressDistance = (props: $Props) => {
  const { dealer } = props;
  const showField = showWidgetField(props.settings || {}, WidgetDealerKeys.DEALER_ADDRESS_DISTANCE_AIR_DISTANCE);
  if (showField && dealer && dealer.address && dealer.address.airDistance && dealer.address.airDistance.distance &&
    dealer.address.airDistance.unit)
    return <DealerDistance
      dealer={ props.dealer }
      configuration={ props.configuration }
      translations={ props.translations }
      settings={ props.settings || {} }
      modifierClass={ props.modifierClass }
    />
  else
    return null;
};

export default DealerAddressDistance;
